import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root') as HTMLElement;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Production builds pre-render "/" into index.html (scripts/prerender.mjs), so
// hydrate that markup rather than rebuilding it. Any other path gets the same
// index.html from CloudFront, but its first render is the catch-all redirect,
// which would not match the home-page markup, so it starts from empty instead.
if (container.hasChildNodes() && window.location.pathname === '/') {
  ReactDOM.hydrateRoot(container, app);
} else {
  container.textContent = '';
  ReactDOM.createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
